/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Aidiagramlabel2Inputs */

const zh_landing_admin_aidiagramlabel2 = /** @type {(inputs: Landing_Admin_Aidiagramlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`光合作用示意图`)
};

const en_landing_admin_aidiagramlabel2 = /** @type {(inputs: Landing_Admin_Aidiagramlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photosynthesis diagram`)
};

const es_landing_admin_aidiagramlabel2 = /** @type {(inputs: Landing_Admin_Aidiagramlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagrama de fotosíntesis`)
};

/**
* | output |
* | --- |
* | "Photosynthesis diagram" |
*
* @param {Landing_Admin_Aidiagramlabel2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_aidiagramlabel2 = /** @type {((inputs?: Landing_Admin_Aidiagramlabel2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Aidiagramlabel2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_aidiagramlabel2(inputs)
	if (locale === "en") return en_landing_admin_aidiagramlabel2(inputs)
	return es_landing_admin_aidiagramlabel2(inputs)
});
export { landing_admin_aidiagramlabel2 as "landing_admin_aiDiagramLabel" }